import Vue from 'vue'
import Vuex from 'vuex'

//Auth
import auth from './modules/auth/auth'
import authLayout from './modules/layouts/auth-layout/auth-layout'
//UI
import notificationStatic from './modules/ui/notifications/static/static'
import notificationModal from './modules/ui/notifications/modal/modal'
import modal from './modules/ui/modal/modal'
import filters from './modules/ui/filters/filters'
import validation from './modules/validation/validation'
import responsive from './modules/ui/responsive/responsive'
//Files
import files from './modules/files/files'

//Admin
import adminBuildings from './modules/data-base/admin/addresses'

//Views
import addresses from './modules/views/addresses/addresses'
import checkups from './modules/views/checkups/checkups'
import staff from './modules/views/staff/staff'
import users from './modules/views/users/users'
import serviceEntities from './modules/views/service-entities/service-entities'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    authLayout,
    notificationStatic,
    notificationModal,
    modal,
    filters,
    validation,
    responsive,
    //Files
    files,
    //Admin
    adminBuildings,
    //Views
    addresses,
    checkups,
    staff,
    users,
    serviceEntities,
  }
})
